import React from 'react'
import { JobList } from './components/JobList'
import { MutateJobLevel } from './components/components/MutateJobLevel'
import { Button } from 'src/components/UI'

export const JobLevels = () => {
    return (
        <div className='flex flex-col gap-3 my-container'>
            <div className='flex flex-row justify-end'>
                <MutateJobLevel mode='add'>
                    <Button  keyTitle={'AddJobLevel'} ></Button>
                </MutateJobLevel>
            </div>

            <JobList />

        </div>
    )
}
